export default __webpack_public_path__ + "static/media/PasswordSuccessfullyReset.39fd21aa.svg";